import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { EducationLevelDataObject } from 'models/service';

export const getEducationsLevel = async () =>
  apiClient.get<EducationLevelDataObject[], ApiClientResponse<EducationLevelDataObject[]>>(routes.user.educationsLevel);
